/**
 * Menüdeki "Kiracı paneli" girişi: kullanıcının bağlı kira sözleşmesi olup olmadığını cihazda önbellekler.
 * Ağ isteği yalnızca hesap menüsü açıldığında ve önbellek eskiyse yapılır (hafif); davet kabul edilince ya da
 * kiracı portalı listesi yüklenince önbellek hemen güncellenir. Kişisel veri saklanmaz: yalnızca { has, at }.
 */
const PREFIX = 'tp:entry:';
export const TENANT_ENTRY_EVENT = 'odazen:tenant-entry';
export const TENANT_ENTRY_MAX_AGE_MS = 6 * 60 * 60 * 1000;

const store = () => {
  try {
    return typeof window !== 'undefined' && window.localStorage ? window.localStorage : null;
  } catch {
    return null;
  }
};

const keyOf = (userId) => (userId != null && String(userId) ? `${PREFIX}${String(userId).slice(0, 64)}` : null);

/** → { has: boolean, at: number } | null */
export const readTenantEntry = (userId) => {
  const s = store();
  const k = keyOf(userId);
  if (!s || !k) return null;
  try {
    const v = JSON.parse(s.getItem(k) || 'null');
    return v && typeof v.has === 'boolean' && Number.isFinite(v.at) ? v : null;
  } catch {
    return null;
  }
};

export const writeTenantEntry = (userId, has, now = Date.now()) => {
  const s = store();
  const k = keyOf(userId);
  if (!s || !k) return;
  try {
    s.setItem(k, JSON.stringify({ has: Boolean(has), at: now }));
  } catch {
    /* kota / özel mod */
  }
  try {
    if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof CustomEvent === 'function') {
      window.dispatchEvent(new CustomEvent(TENANT_ENTRY_EVENT, { detail: { has: Boolean(has) } }));
    }
  } catch {
    /* yoksay */
  }
};

/** Önbellek taze mi (yoksa ya da eskiyse menü açılışında yeniden sorulur) */
export const isTenantEntryFresh = (entry, now = Date.now(), maxAge = TENANT_ENTRY_MAX_AGE_MS) =>
  Boolean(entry) && now - entry.at >= 0 && now - entry.at < maxAge;
